import React from 'react';
import Section from '../ui/Section';
import Card from '../ui/Card';
import { Ruler, HardHat, Building2, FileText, PenTool, ShieldCheck } from 'lucide-react';

const services = [
    {
        icon: <Building2 className="w-10 h-10 text-gold-500" />,
        title: "Structural Design",
        description: "Comprehensive structural analysis and design for residential, commercial, and industrial buildings."
    },
    {
        icon: <Ruler className="w-10 h-10 text-gold-500" />,
        title: "Project Planning",
        description: "Detailed project planning, feasibility studies, and cost estimation to ensure project success."
    },
    {
        icon: <HardHat className="w-10 h-10 text-gold-500" />,
        title: "Construction Supervision",
        description: "On-site supervision to ensure construction adheres to design specifications and safety standards."
    },
    {
        icon: <FileText className="w-10 h-10 text-gold-500" />,
        title: "Technical Consulting",
        description: "Expert advice on structural integrity, material selection, and regulatory compliance."
    },
    {
        icon: <PenTool className="w-10 h-10 text-gold-500" />,
        title: "Renovation & Retrofitting",
        description: "Assessment and strengthening of existing structures to meet modern standards."
    },
    {
        icon: <ShieldCheck className="w-10 h-10 text-gold-500" />,
        title: "Safety Inspections",
        description: "Rigorous safety audits and structural health monitoring for new and existing buildings."
    }
];

const Services = () => {
    return (
        <Section id="services" background="slate">
            <div className="text-center max-w-3xl mx-auto mb-16">
                <h2 className="text-3xl md:text-4xl font-bold mb-4 text-slate-900">Our Services</h2>
                <p className="text-slate-600 text-lg">
                    Providing a full spectrum of civil engineering services tailored to meet the unique challenges of each project.
                </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {services.map((service, index) => (
                    <Card key={index} className="p-8 hover:border-gold-500/50 transition-colors">
                        <div className="mb-6 bg-slate-50 w-16 h-16 rounded-full flex items-center justify-center">
                            {service.icon}
                        </div>
                        <h3 className="text-xl font-bold mb-3 text-slate-900">{service.title}</h3>
                        <p className="text-slate-600 leading-relaxed">
                            {service.description}
                        </p>
                    </Card>
                ))}
            </div>
        </Section>
    );
};

export default Services;
